// extracted by mini-css-extract-plugin
export var cartIcon = "_my-0";
export var cartIconContainer = "_my-1";